import React, { useCallback } from 'react';
import { IPropsOp } from '.';
import Icon, { ICON_NAME } from '../../../../../../components/Icon';
import { ACTION_TYPE, OP_STATUS, OPERATION_TYPE } from '../../../../../../util/varibles/constants';
import SupportView from '../../../../_components/ContentOperation/SupportView';
import WrapperOperation from './_components/WrapperOperation';
import styles from "./style.module.scss";

interface IProps extends IPropsOp {
    operationType: OPERATION_TYPE
    isOwn: boolean
    isVesselOwn: boolean
    permission: any
    status: OP_STATUS
}

const Support: React.FC<IProps> = (props) => {
    const { isOwn, data } = props;

    const edit = useCallback(() => {
        return {
            isShow: true,
            operationType: OPERATION_TYPE.SUPPORT,
            editMode: ACTION_TYPE.EDIT,
            values: data,
        }
    }, [data])


    return <WrapperOperation {...{ ...props, icon: <Icon icon={ICON_NAME.SUPPORT_OP} />, edit }}>
        <div className={[styles['content-wrapper'], styles.layout].join(' ')}>
            <SupportView
                status={props.status}
                data={data}
                isOwn={isOwn}
            />
        </div>
    </WrapperOperation>;
};

export default Support;